import type { User } from '@openclassrooms/sdk-web';
import { localStorage } from '@openclassrooms/utils/local-storage';

const STORAGE_KEY = 'currentUser';

const ONE_MIN_IN_MS = 1000 * 60;
const FIVE_MIN_IN_MS = ONE_MIN_IN_MS * 5;
const ONE_HOUR_IN_MS = ONE_MIN_IN_MS * 60;
const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;

export type UserWithExpiryTime = {
  user: User | null;
  expiryTime: number;
};

export async function setCachedCurrentUser(user: User | null): Promise<UserWithExpiryTime> {
  return localStorage.setItem<UserWithExpiryTime>(STORAGE_KEY, {
    user,
    expiryTime: Date.now() + (user ? FIVE_MIN_IN_MS : ONE_DAY_IN_MS),
  });
}

export function clearCachedCurrentUser(): Promise<UserWithExpiryTime> {
  return setCachedCurrentUser(null);
}

export function removeCachedCurrentUser(): Promise<void> {
  return localStorage.removeItem(STORAGE_KEY);
}

export async function getCachedCurrentUser(): Promise<UserWithExpiryTime | null> {
  const storedUserWithExpiryTime = await localStorage.getItem<UserWithExpiryTime>(STORAGE_KEY);

  if (!storedUserWithExpiryTime || Date.now() >= storedUserWithExpiryTime.expiryTime) {
    return null;
  }

  return storedUserWithExpiryTime;
}
